import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const MyEmissionFactorsLibraryPage = lazyWithChunkReload(() =>
  import("./customer-emission-factors.main").then((m) => ({ default: m.MyEmissionFactorsLibraryPage }))
);
